export const AppRouteNames = {
  // Home
  home: {
    label: "ホーム",
    value: "home",
  },

  // Login
  login: {
    label: "ログイン",
    value: "login",
  },
  recover: {
    label: "新規登録",
    value: "recover",
  },
  resetPassword: {
    label: "パスワード再設定",
    value: "reset_password",
  },
  register: {
    label: "新規登録",
    value: "register",
  },

  // Information
  information: {
    label: "お知らせ一覧",
    value: "information",
  },
  informationDetail: {
    label: "お知らせの詳細",
    value: "information_detail",
  },

  // company
  companyList: {
    label: "企業管理",
    value: "company_list",
  },
  companyCreate: {
    label: "新規企業登録",
    value: "company_create",
  },
  companyEdit: {
    label: "企業編集",
    value: "company_edit",
  },
  companyDetail: {
    label: "企業詳細",
    value: "company_detail",
  },
  companyImport: {
    label: "企業インポート",
    value: "company_import",
  },

  // case
  caseList: {
    label: "案件管理",
    value: "case_list",
  },
  caseCreate: {
    label: "案件管理",
    value: "case_create",
  },
  caseEdit: {
    label: "案件管理",
    value: "case_edit",
  },

  // Contact
  contact: {
    label: "お問い合わせ",
    value: "contact",
  },

  // Talent
  talentList: {
    label: "人材一覧",
    value: "talent_list",
  },
  talentCreate: {
    label: "新規人材登録",
    value: "talent_create",
  },
  talentEdit: {
    label: "人材編集",
    value: "talent_edit",
  },
  talentDetail: {
    label: "人材詳細",
    value: "talent_detail",
  },
  talentImport: {
    label: "人材インポート",
    value: "talent_import",
  },

  // Job
  jobList: {
    label: "求人一覧",
    value: "job_list",
  },
  jobCreate: {
    label: "新規求人登録",
    value: "job_create",
  },
  jobDetail: {
    label: "求人詳細",
    value: "job_detail",
  },
  jobEdit: {
    label: "求人編集",
    value: "job_edit",
  },
  jobImport: {
    label: "求人インポート",
    value: "job_import",
  },

  // Partner
  partnerList: {
    label: "パートナー管理",
    value: "partner_list",
  },
  partnerCreate: {
    label: "新規パートナー登録",
    value: "partner_create",
  },
  partnerDetail: {
    label: "パートナー詳細",
    value: "partner_detail",
  },
  partnerEdit: {
    label: "パートナー編集",
    value: "partner_edit",
  },
  partnerImport: {
    label: "パートナーインポート",
    value: "partner_import",
  },

  // Dashboard
  offerAcceptedList: {
    label: "内定受諾者一覧",
    value: "offer_accepted_list",
  },
  performanceDetail: {
    label: "実績詳細",
    value: "performance_detail",
  },

  // page not found
  pageNotFound: {
    label: "「ページが見つかりません」の画面",
    value: "page_not_found",
  },
  serverErrorPage: {
    label: "サーバーエラーページ",
    value: "server_error_page",
  },

  // Maintenance
  maintenance: {
    label: "メンテナンス",
    value: "maintenance",
  },

  // user setting
  userSettingDetail: {
    label: "ユーザー設定",
    value: "user_setting_detail",
  },
  userSettingEdit: {
    label: "ユーザー設定編集",
    value: "user_setting_edit",
  },
  userSettingChangeEmail: {
    label: "ユーザー設定のメール更新",
    value: "user_setting_change_email",
  },

  // match
  match: {
    label: "紹介会社情報",
    value: "match",
  },
  matchEdit: {
    label: "紹介会社情報の編集",
    value: "match_edit",
  },

  // business report
  businessReport: {
    label: "紹介事業報告書の作成",
    value: "business_report",
  },

  // management ledger
  managementLedger: {
    label: "管理簿",
    value: "management_ledger",
  },
};
